/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AmortizacionRouteImport } from './routes/amortizacion'
import { Route as OperativoRouteImport } from './routes/operativo'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AmortizacionRoute = AmortizacionRouteImport.update({
  id: '/amortizacion',
  path: '/amortizacion',
  getParentRoute: () => rootRouteImport,
} as any)
const OperativoRoute = OperativoRouteImport.update({
  id: '/operativo',
  path: '/operativo',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/amortizacion': typeof AmortizacionRoute
  '/operativo': typeof OperativoRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/amortizacion': typeof AmortizacionRoute
  '/operativo': typeof OperativoRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/amortizacion': typeof AmortizacionRoute
  '/operativo': typeof OperativoRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/amortizacion' | '/operativo'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/amortizacion' | '/operativo'
  id: '__root__' | '/' | '/amortizacion' | '/operativo'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AmortizacionRoute: typeof AmortizacionRoute
  OperativoRoute: typeof OperativoRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/amortizacion': {
      id: '/amortizacion'
      path: '/amortizacion'
      fullPath: '/amortizacion'
      preLoaderRoute: typeof AmortizacionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/operativo': {
      id: '/operativo'
      path: '/operativo'
      fullPath: '/operativo'
      preLoaderRoute: typeof OperativoRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AmortizacionRoute: AmortizacionRoute,
  OperativoRoute: OperativoRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
